import React, { useContext } from 'react';
import { TablePaginationConfig } from 'antd/es/table';
import { ColumnProps } from 'antd/lib/table';
import { SorterResult } from 'antd/lib/table/interface';

import ReportContext from '@totem/components/cyberReview/CyberReportContext';
import { Organization } from '@totem/components/cyberReview/dataTypes';
import TableTitle from '@totem/components/cyberReview/TableTitle';
import UsersSubTable from '@totem/components/cyberReview/UsersSubTable';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import VendorDisplay from '@totem/components/vendors/vendorLogos/vendorDisplay';

import './cyberReport.css';

const ReportTable = () => {
  const { reportData, loading, input, setInput, totalRecords } =
    useContext(ReportContext);
  const columns: ColumnProps<Organization>[] = [
    {
      title: <TableTitle>Organization</TableTitle>,
      dataIndex: 'name',
      key: 'name',
      render: (_, record: Organization) => (
        <VendorDisplay vendorName={record.name} />
      ),
      //className: 'tableAlignTop',
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.name === compB.name ? 0 : compA.name > compB.name ? 1 : -1,
    },
  ];

  const getData = () => {
    if (
      typeof reportData !== 'undefined' &&
      reportData !== null &&
      reportData.organizations !== null
    ) {
      return reportData.organizations;
    }
    return [];
  };

  const handleTableChange = (
    updatedPagination: TablePaginationConfig,
    filters: SorterResult<Organization>,
    sorter,
  ) => {
    const { ...params } = filters;

    let sortDir: string = sorter.order === 'descend' ? '-1' : '1';
    if (typeof sorter.order === 'undefined' || sorter.order === null) {
      if (
        typeof input.sortDirection !== 'undefined' &&
        input.sortDirection !== null
      ) {
        sortDir = input.sortDirection;
      }
    }

    let sortField = input.sortField ? input.sortField : 'lastOccurrence';
    if (
      typeof sorter.field !== 'undefined' &&
      typeof sorter.order !== 'undefined'
    ) {
      sortField = sorter.field;
    }

    // @ts-ignore
    setInput({
      ...input,
      ...params,
      pageSize: updatedPagination.pageSize,
      page: updatedPagination.current,
      sortField,
      sortDirection: sortDir,
    });
  };

  return (
    <>
      <IBTable
        showSorterTooltip
        columns={columns}
        dataSource={getData()}
        onChange={handleTableChange}
        loading={loading}
        rowKey={(record) => record.id}
        pagination={{
          current: input.page,
          pageSize: input.pageSize,
          total: totalRecords,
          showSizeChanger: true,
        }}
        expandable={{
          expandedRowRender: (record) => (
            <UsersSubTable users={record.users} loading={loading} />
          ),
          defaultExpandAllRows: false,
        }}
      />
    </>
  );
};

export default ReportTable;
